import './js/bootstrap.bundle.min.js';
import './scss/fontawesome.scss';
import './scss/bootstrap.scss';
import './scss/style.scss';
import { Collapse } from './js/bootstrap.bundle.min.js';
import { loadHomePage, Storage } from './js/home.js';

//  Variables --------------------
const navbar = document.querySelector('.navbar');
const mediaObj = window.matchMedia(
  '(orientation:landscape) and (max-height:600px)'
);

// ----------------
let firstPlaying = true;
const loadYoutubePlayerListeners = async () => {
  const { onYouTubeIframeAPIReady, stopVideo } = await import(
    './js/youtube_api.js'
  );

  const scrollToTopBtn = document.querySelector('a.fixed-bottom');
  const videoModal = document.getElementById('videoModal');
  const videoId = 'sWecvfsxHgA';

  const closePlayer = () => {
    stopVideo();
    navbar.classList.add('fixed-top');
    scrollToTopBtn.classList.add('show');
  };

  const loadPlayer = () => {
    scrollToTopBtn.classList.remove('show');
    navbar.classList.contains('fixed-top') &&
      navbar.classList.remove('fixed-top');

    // -----------
    firstPlaying === true &&
      videoModal.addEventListener('hide.bs.modal', closePlayer);

    firstPlaying === false &&
      videoModal.removeEventListener('hide.bs.modal', closePlayer);

    onYouTubeIframeAPIReady(videoId);
    firstPlaying = false;
  };

  videoModal.addEventListener('shown.bs.modal', loadPlayer);
};

// ----------------------
const userScroll = () => {
  const scrollToTopBtn = document.querySelector('a.fixed-bottom');

  if (window.scrollY > 1200) {
    !mediaObj.matches && navbar.classList.add('fixed-top', 'opacity-85');
    scrollToTopBtn.classList.add('show');
  } else {
    navbar.classList.remove('fixed-top', 'opacity-85');
    scrollToTopBtn.classList.remove('show');
  }
};

// Close navbar dropdown on link click --------------
const collapseNavbar = () => {
  const navbarCollapse = document.querySelector('.navbar-collapse');
  const bsCollapse = new Collapse(navbarCollapse, { toggle: false });
  const navLinks = document.querySelectorAll('.nav-link');

  navbarCollapse.addEventListener('show.bs.collapse', () => {
    navLinks.forEach((navLink) => {
      navLink.addEventListener('click', () => bsCollapse.hide());
    });
  });
};

function toggleFullScreen(videoEl) {
  if (!document.fullscreenElement) {
    videoEl.requestFullscreen();
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
  }
}
const mediaEventListeners = () => {
  mediaObj.addEventListener('change', (e) => {
    e.matches &&
      navbar.classList.contains('fixed-top') &&
      navbar.classList.remove('fixed-top');
  });

  const navbarContainer = navbar.querySelector('.navbar-container');

  mediaObj.matches &&
    navbar.classList.contains('navbar-expand-lg') &&
    navbar.classList.replace('navbar-expand-lg', 'navbar-expand') &&
    navbarContainer.classList.replace('container-mlg', 'container-fluid');

  mediaObj.addEventListener('change', () => {
    mediaObj.matches &&
      navbar.classList.contains('navbar-expand-lg') &&
      navbar.classList.replace('navbar-expand-lg', 'navbar-expand') &&
      navbarContainer.classList.replace('container-mlg', 'container-fluid');

    !mediaObj.matches &&
      navbar.classList.contains('navbar-expand') &&
      navbar.classList.replace('navbar-expand', 'navbar-expand-lg');
    navbarContainer.classList.replace('container-fluid', 'container-mlg');
  });
};

// ------------------
const init = () => {
  loadHomePage();
  collapseNavbar();
  mediaEventListeners();
  Storage.getCurrentPage() === 'home-page' && loadYoutubePlayerListeners();

  window.addEventListener('scroll', userScroll);
};

window.addEventListener('DOMContentLoaded', init);
